import {SchedulesApi} from 'Agent/Commissions/api';
import {CommissionScheduleFilter} from 'Agent/Commissions/ducks/commissionSchedules';
import {AgencyFilters} from 'Shared/models/AgencyFilters';
import {getAxiosConfig, handleResponse} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {Sort, toSortQuerystringParams} from 'Shared/components/PagedView/Table/Sort';

const commissionScheduleApi = new SchedulesApi(undefined, process.env.REACT_APP_BASE_GATEWAY_URL, axiosInstance);

const getSchedules = (filter: CommissionScheduleFilter, agencyFilter: AgencyFilters, sort: Sort | undefined) =>
  commissionScheduleApi
    .searchCommissionSchedules('1', {
      params: {...filter, ...agencyFilter, ...(sort && toSortQuerystringParams(sort))},
      ...getAxiosConfig(),
    })
    .then(handleResponse);

export default {
  getSchedules,
};
